import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { REQUEST } from '@personal-area/common';
import { Observable } from 'rxjs';
import { APP_BASE_HREF } from '@angular/common';

import { IS_API_GATEWAY, autoRegURLs } from '@personal-area/global/http/models';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {

  private _request = inject(REQUEST);
  private readonly _baseHref = inject(APP_BASE_HREF);
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hostname = this._request.get('x-forwarded-host') || this._request.get('host') as string;
    const domain = this._request.protocol + '://' + hostname;

    let url = `${domain}${request.url.startsWith('/partners') ? '' : '/api'}${request.url}`;
    
    const isAssetUrl = request.url.startsWith('/assets');
    const isStorageUrl = request.url.startsWith('/storage');

    if (isAssetUrl || isStorageUrl) {
      url = domain;
      if (environment.configsHost[hostname]) {
        url = environment.configsHost[hostname];
      } else if (environment.configsHost['default']) {
        url = environment.configsHost['default'];
      }
      url += (isAssetUrl ? `${this._baseHref}` : '') + request.url + '?ts=' + Date.parse((new Date()).toISOString().split(':')[0] + ':00:00');
    } else if (request.context.get(IS_API_GATEWAY)) {
      url = `${domain}/api-gw${request.url}`;
    } else if (
      request.url.startsWith(autoRegURLs.status) ||
      request.url.startsWith('/site') ||
      request.url.startsWith('/clientapi') ||
      request.url.startsWith('/content') ||
      request.url.includes('googleapis') ||
      request.url.includes('accounts.google.com')
    ) {
      url = request.url;
    }
    request = request.clone({ url: url });
    return next.handle(request);
  }
}
